export default "__VITE_ASSET__9f990d34__"